var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-password"},[_c('MobileNav',{attrs:{"page_title":_vm.nav_title}}),_c('div',{staticClass:"background-image"},[_c('ChangePasswordComponent',{staticClass:"change-password-component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }